module.exports = __webpack_public_path__ + "static/img/icon_daiyunying@2x.a83090a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/productOperation/socialPlatform/icon_daiyunying@2x.png
// module id = hMeK
// module chunks = 0